<template>
  <div v-if="error" id="card-errors" role="alert">
    <p class="mbn mtm">
      <i class="fas fa-times-circle"></i>
      <span v-html="error"></span>
    </p>
  </div>
  <div v-else>&nbsp;</div>
</template>

<script>
export default {
  name: 'PaymentError',
  data() {
    return {};
  },
  props: {
    error: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
#card-errors {
  color: #fa755a;
  display: grid;
  align-items: center;
  text-align: center;
}

</style>
